// extracted by mini-css-extract-plugin
module.exports = {"discountedPrice":"shared-components-ProductPrice-styles__discountedPrice--1YTYQ"};